import { get, includes, filter, find, head, sortBy } from 'lodash';
import { DateTime } from 'luxon';

export const isLoading = (state, teamId) => {
  const loading = get(state, 'teams.matchReports.currentlyLoading');
  return includes(loading, teamId);
};

export const hasLoaded = (state, teamId) => {
  const loaded = get(state, 'teams.matchReports.hasLoaded');
  return includes(loaded, teamId);
};

export const getSeasons = (state) =>
  sortBy(get(state, 'teams.matchReports.seasons'), ['fixture.date']);

export const getSeason = (state, seasonId) => {
  const seasons = getSeasons(state);
  return seasonId ? find(seasons, { id: seasonId }) : head(seasons);
};

export const getReports = (state, teamId, seasonId) => {
  const season = getSeason(state, seasonId);
  const teamReports = filter(get(state, 'teams.matchReports.reports'), { team_id: teamId });

  if (!season) {
    return teamReports;
  }

  const seasonStart = DateTime.fromISO(season.start);
  const seasonEnd = DateTime.fromISO(season.end);

  return filter(teamReports, (report) => {
    const fixtureDate = DateTime.fromISO(report.fixture.date);
    return fixtureDate >= seasonStart && fixtureDate <= seasonEnd;
  });
};

export const getLoadingError = (state, teamId) =>
  find(get(state, 'teams.matchReports.loadingError'), { teamId });
